
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { DialogComponent } from './dialog/dialog.component';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { ContactInfosComponent } from './contact-infos.component';

const routes: Routes = [
    {
        path     : 'contact-infos',
        component: ContactInfosComponent,
        data :{
            permission:{
                only :['role1','role2']
            }
        },
        canActivate:[AuthGuard,RoleGuard]
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
      ContactInfosComponent,
        DialogComponent
    ],
    entryComponents: [DialogComponent],
    providers:[
        AuthGuard,RoleGuard
    ]
})
export class ContactInfosModule
{
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/contact-infos/contact-infos.module.ts